import { ValidationText } from '../constants'

/**
 * バリデーション時の表示メッセージ
 * @param {string} label inputの項目名
 * @param {array} terms バリデーションの条件やオプション
 */

export const validateMessage = {
    // 必須
    required(label, action, terms) {
        return `${label}は必ず${validateMessageOption.input[action]}してください。`
    },
    // 必須(個人情報入力)
    required_user(label, action, terms) {
        return `${label}は必ず${validateMessageOption.input[action]}してください。`
    },
    // 必須処理(チェックが入っているかどうか)
    required_checked(label, action, terms) {
        return `${label}は必ずチェックしてください。`
    },
    // 必須処理(指定した他のフィールドかつ自分のどれか一つでも存在していなければエラー)
    required_without(label, action, terms) {
        return `${label}は必ず${validateMessageOption.input[action]}してください。`
    },
    /**
     * 必須処理(他のフィールドが値のどれかと一致している場合、このフィールドが存在し、かつ空でないことをバリデートします。)
     * @param {string} label // 必須対象項目
     * @param {string} action // inputのtype
     * @param {array} terms // option
     */
    required_if(label, action, terms) {
        return `${label}は必ず${validateMessageOption.input[action]}してください。`
    },
    /**
     * 必須処理(他のフィールドが値のどれとも一致していない場合、このフィールドが存在し、かつ空でないことをバリデートします。)
     * @param {string} label // 必須対象項目
     * @param {string} action // inputのtype
     * @param {array} terms // option
     */
    required_unless(label, action, terms) {
        return `${label}は必ず${validateMessageOption.input[action]}してください。`
    },
    /**
     * 必須処理(他のフィールドが値のどれかと一致している場合と指定した他のフィールドかつ自分のどれか一つでも存在して場合、このフィールドが存在し、かつ空でないことをバリデートします。)
     * @param {string} label // 必須対象項目
     * @param {string} action // inputのtype
     * @param {array} terms // option
     */
    required_if_without(label, action, terms) {
        return `${label}は必ず${validateMessageOption.input[action]}してください。`
    },
    // 最小金額
    min(label, action, terms) {
        return `${label}は${terms[0]}万円以上でご利用ください。`
    },
    // 最大金額
    max(label, action, terms) {
        return `${label}は${terms[0]}万円以下でご利用ください。`
    },
    // 以上
    more(label, action, terms) {
        return `${label}は${terms[0]}以上で${validateMessageOption.input[action]}してください。`
    },
    // 以下
    less(label, action, terms) {
        return `${label}は${terms[0]}以下で${validateMessageOption.input[action]}してください。`
    },
    // 比較対象の~%までのご利用金額
    percent(label, action, terms) {
        return `${label}は${ValidationText[terms[1]]}の${terms[0]}%まででご利用ください。`
    },
    /**
     *
     * @param {string} label // 必須対象項目
     * @param {string} action // inputのtype
     * @param {array} terms // option
     */
    lt(label, action, terms) {
        return `${label}は${ValidationText[terms[0]]}${validateMessageOption.lt_mold[terms[1]]}`
    },
    /**
     * 日本語バリデーション
     * @param {string} label // 必須対象項目
     * @param {string} action // inputのtype
     * @param {array} terms // option
     */
    japanese(label, action, terms) {
        return `${label}は数字や半角カナや記号は入力はできません。`
    },
    string(label, action, terms) {
        return `${label}は文字列で入力してください。`
    },
    // カタカナ
    kana(label, action, terms) {
        return `${label}はカタカナを必ず入力してください。`
    },
    // スペース混じりのカタカナ
    kana_with_space(label, action, terms) {
        return `${label}はカタカナを必ず入力してください。`
    },
    // 文字数
    maxlen(label, action, terms) {
        return `${label}は${terms[0]}文字までしか入力できません。`
    },
    // 全角
    full_width(label, action, terms) {
        return `${label}は数字や半角カナや記号は入力はできません。`
    },
    // 半角数字
    integer(label, action, terms) {
        return `${label}は必ず半角数字で入力してください。`
    },
    // 郵便番号
    post(label, action, terms) {
        return `${label}は必ず半角数字と半角ハイフンで入力してください。`
    },
    // アドレス
    address(label, action, terms) {
        return `${label}のフォーマットが間違えています。`
    },
    // メールアドレス
    email(label, action, terms) {
        return `${label}の正しいメールアドレスを入力してください。`
    },
    // 電話
    tel(label, action, terms) {
        return `${label}の正しい電話番号を入力してください。`
    },
    // 日付の比較(以前)
    date_over(label, action, terms) {
        return `${label}は必ず${type[terms[0]]}以前にしてください。`
    },
    // 日付の比較(以降)
    date_under(label, action, terms) {
        return `${label}は必ず${type[terms[0]]}以降にしてください。`
    },
    // 範囲
    range(label, action, terms) {},
    // 誕生日範囲
    birthday_range(label, action, terms) {
        const range = terms[1].split('~')
        return `年齢が${range[0]}歳以上から${range[1]}歳以下の人がご登録可能です。`
    },
    // 住所検索
    post_search(label, action, terms) {
        return `住所が見つかりませんでした。再度ご確認ください。`
    },
    // 住所カナ
    address_kana(label, action, terms) {
        return `${label}はカタカナと英数字と特定の記号で入力してください。`
    },
    // 会社カナ
    company_kana(label, action, terms) {
        return `${label}はカタカナと英数字で入力してください。`
    },
    // 単位
    unit(label, action, terms) {
        return `${label}は${terms[0]}円単位で入力してください。`
    },
    /**
     * 上限のバリデーション
     * @param {string} label // 必須対象項目
     * @param {string} action // inputのtype
     * @param {array} terms // option
     */
    limit(label, action, terms) {
        const array = terms[0].split(','),
            limit = array[0],
            type = array[1],
            unit = array[2]
        return `${label}は${limit}${unit}までが${validateMessageOption.limit[type]}です。`
    },
    /**
     * 範囲のバリデーション
     * @param {string} label // 必須対象項目
     * @param {string} action // inputのtype
     * @param {array} terms // option
     */
    between(label, action, terms) {
        const array = terms[0].split(','),
            min = array[0],
            max = array[1],
            unit = array[2]
        return `${label}は${min}${unit}~${max}${unit}までの範囲です。`
    },
    /**
     * 日付が有効かどうかのバリデーション
     * @param {string} label // 必須対象項目
     * @param {string} action // inputのtype
     * @param {array} terms // option
     */
    date(label, action, terms) {
        return `${label}には有効な日付を指定してください。`
    },
    calc_remainder(label, action, terms) {
        return `${label}の金額が支払合計額と一致しません。`
    },
    /**
     * カスタムバリデーション(Eventを強制発火させメッセージをカスタマイズして表示)
     * @param {string} label // 必須対象項目
     * @param {string} action // inputのtype
     * @param {array} terms // option
     */
    message_custom(label, action, terms) {
        return terms[0]
    }
}

const validateMessageOption = {
    // inputのtypeを定義
    input: {
        input: '入力',
        select: '選択',
        radio: 'いずれかを選択',
        check: 'チェック',
        upload: 'アップロード',
        default: '指定'
    },
    // 日付のtpyeを定義
    date: {
        year: '年',
        month: '今月',
        date: '今日'
    },
    lt_mold: {
        numeric: 'より小さな値を指定してください。'
    },
    limit: {
        lower: '下限',
        upper: '上限'
    }
}